import Vue from "vue";
import VueRouter from "vue-router";
import store from "src/store";

const ConsoleLayout = (resolve) => require(["../pages/ConsoleLayout"], resolve);
const Dashboard = (resolve) => require(["../pages/Dashboard"], resolve);
const ForeDashboard = (resolve) => require(["../pages/foreDashboard/ForeDashboard"], resolve);
const Entry = (resolve) => require(["../pages/order/entry/Entry"], resolve);
const EntryCreate = (resolve) => require(["../pages/order/entry/EntryCreate"], resolve);
const ReEntryCreate = (resolve) => require(["../pages/order/entry/ReEntryCreate"], resolve);
const Distribution = (resolve) => require(["../pages/order/distribution/Distribution"], resolve);
const Partner = (resolve) => require(["../pages/our/partner/Partner"], resolve);
const UserOrganization = (resolve) => require(["../pages/our/userOrganization/UserOrganization"], resolve);
const MotherTemplate = (resolve) => require(["../pages/our/billing/MotherTemplate"], resolve);
const Product = (resolve) => require(["../pages/our/product/Product"], resolve);
const Project = (resolve) => require(["../pages/our/project/Project"], resolve);
const Businessarea = (resolve) => require(["../pages/our/businessarea/Businessarea"], resolve);
const Ourvehicle = (resolve) => require(["../pages/our/vehicle/Ourvehicle"], resolve);
const Ourdriver = (resolve) => require(["../pages/our/driver/Ourdriver"], resolve); //司机管理
const driversWages = (resolve) => require(["../pages/our/driver/DriverWages"], resolve); //司机工资
const Site = (resolve) => require(["../pages/our/site/Site"], resolve);
const CapacityPool = (resolve) => require(["../pages/our/capacityPool/CapacityPool"], resolve);
const LineManage = (resolve) => require(["../pages/our/lineManage/LineManage"], resolve);
const DeviceManage = (resolve) => require(["../pages/our/machine/DeviceManage"], resolve);
const Query = (resolve) => require(["../pages/our/query/Query"], resolve);
const Machine = (resolve) => require(["../pages/our/machine/Machine"], resolve);
const Exceptcreate = (resolve) => require(["../pages/except/Exceptcreate"], resolve);
const Exceptdeal = (resolve) => require(["../pages/except/Exceptdeal"], resolve);
const Scheduleform = (resolve) => require(["../pages/schedule/Scheduleform"], resolve);
const Schedulecreate = (resolve) => require(["../pages/schedule/Schedulecreate"], resolve);
const Receiptcreate = (resolve) => require(["../pages/receipt/Receiptcreate"], resolve);
const Receiptsure = (resolve) => require(["../pages/receipt/Receiptsure"], resolve);
const Plan = (resolve) => require(["../pages/plan/plan/Plan"], resolve);
const Planmap = (resolve) => require(["../pages/plan/plan/Planmap"], resolve);
const Planlook = (resolve) => require(["../pages/plan/plan/Planlook"], resolve);
const CityPlan = (resolve) => require(["../pages/plan/cityPlan/CityPlan"], resolve);
const PlanlookCity = (resolve) => require(["../pages/plan/cityPlan/PlanlookCity"], resolve);
const AutoLinePlan = (resolve) => require(["../pages/plan/cityPlan/AutoLinePlan"], resolve);
const GoodsType = (resolve) => require(["../pages/our/goodsType/GoodsType"], resolve);
const MonitoringStrategy = (resolve) => require(["../pages/our/monitoringStrategy/MonitoringStrategy"], resolve);
const AutoLineStrategy = (resolve) => require(["../pages/our/autoLineStrategy/AutoLineStrategy"], resolve);
const Motorcade = (resolve) => require(["../pages/our/motorcade/Motorcade"], resolve);
const PlanDispatch = (resolve) => require(["../pages/planDispatch/PlanDispatch"], resolve);
const TransferList = (resolve) => require(["../pages/transfer/TransferList"], resolve);
const TransferDelivery = (resolve) => require(["../pages/transfer/TransferDelivery"], resolve);
const SendGoods = (resolve) => require(["../pages/transfer/SendGoods"], resolve);
const TransportPlan = (resolve) => require(["../pages/transportPlan/TransportPlan"], resolve);
const DataResource = (resolve) => require(["../pages/account/DataResource"], resolve);
const OilPrices = (resolve) => require(["../pages/account/OilPrices"], resolve);
const Serviceitems = (resolve) => require(["../pages/account/Serviceitems"], resolve);
const BillingItems = (resolve) => require(["../pages/account/BillingItems"], resolve);
const ContractManage = (resolve) => require(["../pages/account/ContractManage"], resolve);
const QuoteMaintain = (resolve) => require(["../pages/account/QuoteMaintain"], resolve);
const CalculatorManage = (resolve) => require(["../pages/account/CalculatorManage"], resolve);
const BillingRules = (resolve) => require(["../pages/account/BillingRules"], resolve);
const BillingShares = (resolve) => require(["../pages/account/BillingShares"], resolve);
const AccountsReceivable = (resolve) => require(["../pages/account/accountsReceivable/AccountsReceivable"], resolve);
const BillingConfirm = (resolve) => require(["../pages/account/accountsReceivable/BillingConfirm"], resolve);
const Reconciliation = (resolve) => require(["../pages/account/accountsReceivable/Reconciliation"], resolve);
const BillPayable = (resolve) => require(["../pages/account/billPayable/BillPayable"], resolve);
const BillConfirm = (resolve) => require(["../pages/account/billPayable/BillConfirm"], resolve);
const BillReconciliation = (resolve) => require(["../pages/account/billPayable/BillReconciliation"], resolve);
const BillQueryPayable = (resolve) => require(["../pages/account/billQuery/BillQueryPayable"], resolve);
const BillQueryConfirm = (resolve) => require(["../pages/account/billQuery/BillQueryConfirm"], resolve);
const BillQueryReconciliation = (resolve) => require(["../pages/account/billQuery/BillQueryReconciliation"], resolve);
const ReceivablesDetail = (resolve) => require(["../pages/account/billQuery/ReceivablesDetail"], resolve);
const ReportList = (resolve) => require(["../pages/report/reportdownload/ReportList"], resolve);
const DynamicReport = (resolve) => require(["../pages/report/DynamicReport"], resolve);
const DynamicReportInfo = (resolve) => require(["../pages/report/DynamicReportInfo"], resolve);
const Ability = (resolve) => require(["../pages/setup/ability/Ability"], resolve);
const Orders = (resolve) => require(["../pages/track/orders/Orders"], resolve);
const OrdersSingle = (resolve) => require(["../pages/track/orders/OrdersSingle"], resolve);
const OrdersMultiple = (resolve) => require(["../pages/track/orders/OrdersMultiple"], resolve);
const Roads = (resolve) => require(["../pages/track/roads/Roads"], resolve);
const RoadsSingle = (resolve) => require(["../pages/track/roads/RoadsSingle"], resolve);
const RoadsMultiple = (resolve) => require(["../pages/track/roads/RoadsMultiple"], resolve);
const TransportInfo = (resolve) => require(["../pages/track/TransportInfo"], resolve);
const TaskInfo = (resolve) => require(["../pages/track/TaskInfo"], resolve);
const TransportContent = (resolve) => require(["../pages/track/TransportContent"], resolve);
const Number = (resolve) => require(["../pages/our/number/Number"], resolve);
const SynchronousQuery = (resolve) => require(["../pages/our/number/SynchronousQuery"], resolve);
const PerforMeet = (resolve) => require(["../pages/perform/PerforMeet"], resolve);
const PerformGoods = (resolve) => require(["../pages/perform/PerformGoods"], resolve);
const PerformTransit = (resolve) => require(["../pages/perform/PerformTransit"], resolve);
const PerformSendGoods = (resolve) => require(["../pages/perform/PerformSendGoods"], resolve);
const ReturnGoods = (resolve) => require(["../pages/perform/ReturnGoods"], resolve);
const Receiptemail = (resolve) => require(["../pages/receipt/Receiptemail"], resolve);
const Message = (resolve) => require(["../pages/setup/message/Message"], resolve);
const MessageTemplate = (resolve) => require(["../pages/setup/messageTemplate/MessageTemplate"], resolve);
const ConsoleLoading = (resolve) => require(["../pages/ConsoleLoading"], resolve);
const Account = (resolve) => require(["../pages/setup/account/Account"], resolve);
const Permission = (resolve) => require(["../pages/setup/permission/Permission"], resolve);
const MachineCreate = (resolve) => require(["../pages/our/machine/MachineCreate"], resolve);
const TempMonitoring = (resolve) => require(["../pages/track/tempMonitoring/TempMonitoring"], resolve);
const Forexceptcreate = (resolve) => require(["../pages/forexcept/Forexceptcreate"], resolve);
const Forexceptdeal = (resolve) => require(["../pages/forexcept/Forexceptdeal"], resolve);
const DistributionMonitor = (resolve) => require(["../pages/distribution/monitor"], resolve);
const Forereceiptsure = (resolve) => require(["../pages/forereceipt/Forereceiptsure"], resolve);
const Foreaccountroad = (resolve) => require(["../pages/foreaccount/Foreaccountroad"], resolve);
const Forentry = (resolve) => require(["../pages/foreorder/forentry/Forentry"], resolve);
const ForentryCreate = (resolve) => require(["../pages/foreorder/forentry/ForentryCreate"], resolve);
const ForReEntryCreate = (resolve) => require(["../pages/foreorder/forentry/ForReEntryCreate"], resolve);
const Forelook = (resolve) => require(["../pages/forecheck/forelook/Forelook"], resolve);
const ForelookSingle = (resolve) => require(["../pages/forecheck/forelook/ForelookSingle"], resolve);
const Foreability = (resolve) => require(["../pages/foresetup/foreability/Foreability"], resolve);
const Foremessage = (resolve) => require(["../pages/foresetup/foremessage/Foremessage"], resolve);
const Foreaccount = (resolve) => require(["../pages/foresetup/foreaccount/Foreaccount"], resolve);
const Forepermission = (resolve) => require(["../pages/foresetup/forepermission/Forepermission"], resolve);
const Forepartner = (resolve) => require(["../pages/foreour/forepartner/Forepartner"], resolve);
const ForeuserOrganization = (resolve) => require(["../pages/foreour/foreuserOrganization/ForeuserOrganization",], resolve);
const Foreproject = (resolve) => require(["../pages/foreour/foreproject/Foreproject"], resolve);
const Foresite = (resolve) => require(["../pages/foreour/foresite/Foresite"], resolve);
const Notice = (resolve) => require(["../pages/notice/Notice"], resolve);
const Autoreport = (resolve) => require(["../pages/setup/autoreport/Autoreport"], resolve);
const ExceptionType = (resolve) => require(["../pages/setup/exceptionType/ExceptionType"], resolve);
const VehicleType = (resolve) => require(["../pages/our/vehicleType/VehicleType"], resolve);
const Quotation = (resolve) => require(["../pages/quotation/Quotation"], resolve);
const CompanyCost = (resolve) => require(["../pages/financialStatements/CompanyCost"], resolve);
const GroupCost = (resolve) => require(["../pages/financialStatements/GroupCost"], resolve);
const BusinessGroup = (resolve) => require(["../pages/setup/businessGroup/BusinessGroup"], resolve);
const BoardSub = (resolve) => require(["../pages/report/board/sub"], resolve);
const BoardList = (resolve) => require(["../pages/report/board/list"], resolve);
const VehicleMonitoring = (resolve) => require(["../pages/vehicleMonitoring/VehicleMonitoring"], resolve);
const SiteList = (resolve) => require(["../pages/site/SiteList.vue"], resolve);
const SiteAdd = (resolve) => require(["../pages/site/SiteAdd.vue"], resolve);
const HistorySite = (resolve) => require(["../pages/site/HistorySite.vue"], resolve);
const DetailHistory = (resolve) => require(["../pages/site/DetailHistory.vue"], resolve);
const CustomerAdd = (resolve) => require(["../pages/customer/CustomerAdd.vue"], resolve);
const AddressList = (resolve) => require(["../pages/address/AddressList.vue"], resolve);
const ChangeStatusBypass = (resolve) => require(["../pages/update-status/bypass-status/BypassStatus.vue"], resolve);
const ChangeStatusShipment = (resolve) => require(["../pages/update-status/shipment-status/ShipmentStatus.vue"], resolve);
const ChangeStatusShipmentHistory = (resolve) => require(["../pages/update-status/shipment-status/ShipmentStatusHistory.vue"], resolve);
const CustomerList = (resolve) => require(["../pages/customer/CustomerList.vue"], resolve);
const CustomerHistory = (resolve) => require(["../pages/customer/CustomerHistory.vue"], resolve);
const CustomerDetailHistory = (resolve) => require(["../pages/customer/CustomerDetailHistory.vue"], resolve);
const MasterDataPage = (resolve) => require(["../pages/site/MasterDataPage.vue"], resolve);

Vue.use(VueRouter);

export const router = new VueRouter({
  history: true,
  hashbang: false,
  base: __dirname,
  mode: "history",
  routes: [
    { path: "/", name: "console", component: ConsoleLoading },
    { path: "/searchs", name: "searchDemo", component: ConsoleLayout },
    {
      path: "/console",
      component: ConsoleLayout,
      children: [
        { path: "dashboard", name: "dashboard", component: Dashboard }
      ]
    },
    {
      path: "/order",
      component: ConsoleLayout,
      children: [
        { path: "entry", name: "entry", component: Entry },
        { path: "entry/create", name: "entryCreate", component: EntryCreate },
        { path: "entry/recreate", name: "reEntryCreate", component: ReEntryCreate },
        { path: "distribute", name: "distribution", component: Distribution }
      ]
    },
    {
      path: "/update-status",
      name: "updateStatus",
      redirect: { name: "bypassStatus" },
      component: ConsoleLayout,
      children: [
        { path: "bypass-status", name: "bypassStatus", component: ChangeStatusBypass },
        {
          path: "shipment-status",
          component: MasterDataPage,
          children: [
            { path: "", name: "ShipmentStatus", component: ChangeStatusShipment },
            { path: "history", name: "ShipmentStatusHistory", component: ChangeStatusShipmentHistory }
          ]
        },
      ],
    },
    {
      path: "/plan",
      component: ConsoleLayout,
      children: [
        { path: "", name: "plan", component: Plan },
        { path: "planLook", name: "planlook", component: Planlook },
        { path: "planmap", name: "planmap", component: Planmap },
        { path: "cityPlan", name: "cityPlan", component: CityPlan },
        { path: "planlookCity", name: "planlookCity", component: PlanlookCity },
        { path: "autoLinePlan", name: "autoLinePlan", component: AutoLinePlan }
      ]
    },
    {
      path: "/perform",
      component: ConsoleLayout,
      children: [
        { path: "meet", name: "perforMeet", component: PerforMeet },
        { path: "goods", name: "performGoods", component: PerformGoods },
        { path: "transit", name: "performTransit", component: PerformTransit },
        { path: "sendGoods", name: "performSendGoods", component: PerformSendGoods },
        { path: "return", name: "Return", component: ReturnGoods }
      ]
    },
    {
      path: "/except",
      component: ConsoleLayout,
      children: [
        { path: "exceptcreate", name: "exceptcreate", component: Exceptcreate },
        { path: "exceptdeal", name: "exceptdeal", component: Exceptdeal }
      ]
    },
    {
      path: "/distribution",
      component: ConsoleLayout,
      children: [
        { path: "monitor", name: "distributionMonitor", component: DistributionMonitor }
      ]
    },
    {
      path: "/schedule",
      component: ConsoleLayout,
      children: [
        { path: "scheduleForm", name: "scheduleform", component: Scheduleform },
        { path: "schedulecreate", name: "schedulecreate", component: Schedulecreate }
      ]
    },
    {
      path: "/receipt",
      component: ConsoleLayout,
      children: [
        { path: "receiptCreate", name: "receiptcreate", component: Receiptcreate },
        { path: "receiptSure", name: "receiptsure", component: Receiptsure },
        { path: "receiptEmail", name: "receiptemail", component: Receiptemail }
      ]
    },
    {
      path: "/vehicle",
      component: ConsoleLayout,
      children: [
        { path: "vehicleMonitoring", name: "vehicleMonitoring", component: VehicleMonitoring }
      ]
    },
    {
      path: "/account",
      component: ConsoleLayout,
      children: [
        { path: "calculatormanage", name: "CalculatorManage", component: CalculatorManage },
        { path: "serviceitems", name: "Serviceitems", component: Serviceitems },
        { path: "billingitems", name: "BillingItems", component: BillingItems },
        { path: "contractmanage", name: "ContractManage", component: ContractManage },
        { path: "quotemaintain", name: "QuoteMaintain", component: QuoteMaintain },
        { path: "dataresource", name: "DataResource", component: DataResource },
        { path: "oilprice", name: "OilPrices", component: OilPrices },
        { path: "billingrules", name: "BillingRules", component: BillingRules },
        { path: "billingshares", name: "BillingShares", component: BillingShares },
        { path: "accountsReceivable", name: "accountsReceivable", component: AccountsReceivable },
        { path: "billingConfirm", name: "billingConfirm", component: BillingConfirm },
        { path: "reconciliation", name: "reconciliation", component: Reconciliation },
        { path: "billPayable", name: "billPayable", component: BillPayable },
        { path: "billConfirm", name: "billConfirm", component: BillConfirm },
        { path: "billReconciliation", name: "billReconciliation", component: BillReconciliation },
        { path: "billQueryPayable", name: "billQueryPayable", component: BillQueryPayable },
        { path: "billQueryConfirm", name: "billQueryConfirm", component: BillQueryConfirm },
        { path: "billQueryReconciliation", name: "billQueryReconciliation", component: BillQueryReconciliation },
        { path: "ReceivablesDetail", name: "ReceivablesDetail", component: ReceivablesDetail }
      ]
    },
    {
      path: "/report",
      component: ConsoleLayout,
      children: [
        { path: "board/sub", name: "BoardSub", component: BoardSub },
        { path: "board/list", name: "BoardList", component: BoardList },
        { path: "reportdownload/reportlist", name: "reportList", component: ReportList },
        { path: "dynamicReport", name: "dynamicReport", component: DynamicReport },
        { path: "dynamicReportInfo", name: "dynamicReportInfo", component: DynamicReportInfo }
      ]
    },
    {
      path: "/setup",
      component: ConsoleLayout,
      children: [
        { path: "ability", name: "ability", component: Ability },
        { path: "message", name: "message", component: Message },
        { path: "account", name: "account", component: Account },
        { path: "permission", name: "permission", component: Permission },
        { path: "messageTemplate", name: "messageTemplate", component: MessageTemplate },
        { path: "autoreport", name: "autoreport", component: Autoreport },
        { path: "exceptionType", name: "ExceptionType", component: ExceptionType },
        { path: "businessGroup", name: "BusinessGroup", component: BusinessGroup }
      ]
    },
    {
      path: "/track",
      component: ConsoleLayout,
      children: [
        { path: "orders", name: "orders", component: Orders },
        { path: "orders/single", name: "ordersSingle", component: OrdersSingle },
        { path: "orders/multiple", name: "ordersMultiple", component: OrdersMultiple },
        { path: "roads", name: "roads", component: Roads },
        { path: "roads/single", name: "roadsSingle", component: RoadsSingle },
        { path: "roads/multiple", name: "roadsMultiple", component: RoadsMultiple },
        { path: "transportInfo", name: "transportInfo", component: TransportInfo },
        { path: "taskInfo", name: "taskInfo", component: TaskInfo },
        { path: "transportContent", name: "transportContent", component: TransportContent },
        { path: "tempMonitoring", name: "tempMonitoring", component: TempMonitoring }
      ]
    },
    {
      path: "/our",
      component: ConsoleLayout,
      children: [
        { path: "partner", name: "partner", component: Partner },
        { path: "userOrganization", name: "userOrganization", component: UserOrganization },
        { path: "billing/mothertemplate", name: "motherTemplate", component: MotherTemplate },
        { path: "product", name: "product", component: Product },
        { path: "project", name: "project", component: Project },
        { path: "businessarea", name: "businessarea", component: Businessarea },
        { path: "site", name: "site", component: Site },
        { path: "capacityPool", name: "capacityPool", component: CapacityPool },
        { path: "lineManage", name: "lineManage", component: LineManage },
        { path: "machine/deviceManage", name: "deviceManage", component: DeviceManage },
        { path: "ourvehicle", name: "ourvehicle", component: Ourvehicle },
        { path: "drivers", name: "ourdriver", component: Ourdriver },
        { path: "driverswages", name: "driversWages", component: driversWages },
        { path: "machine", name: "machine", component: Machine },
        { path: "number", name: "number", component: Number },
        { path: "synchronousQuery", name: "synchronousQuery", component: SynchronousQuery },
        { path: "machine/create", name: "machineCreate", component: MachineCreate },
        { path: "query", name: "query", component: Query },
        { path: "goodsType", name: "goodsType", component: GoodsType },
        { path: "monitoringStrategy", name: "monitoringStrategy", component: MonitoringStrategy },
        { path: "autoLineStrategy", name: "autoLineStrategy", component: AutoLineStrategy },
        { path: "fleet", name: "motorcade", component: Motorcade },
        { path: "vehicleType", name: "vehicleType", component: VehicleType }
      ]
    },
    {
      path: "/planDispatch",
      component: ConsoleLayout,
      children: [
        { path: "planDispatch", name: "planDispatch", component: PlanDispatch }
      ]
    },
    {
      path: "/transportPlan",
      component: ConsoleLayout,
      children: [
        { path: "transportPlan", name: "transportPlan", component: TransportPlan }
      ]
    },
    {
      path: "/foreconsole",
      component: ConsoleLayout,
      children: [
        { path: "foredashboard", name: "foreDashboard", component: ForeDashboard }
      ]
    },
    {
      path: "/forexcept",
      component: ConsoleLayout,
      children: [
        { path: "forexceptcreate", name: "forexceptcreate", component: Forexceptcreate },
        { path: "forexceptdeal", name: "forexceptdeal", component: Forexceptdeal }
      ]
    },
    {
      path: "/forereceipt",
      component: ConsoleLayout,
      children: [
        { path: "forereceiptSure", name: "forereceiptsure", component: Forereceiptsure }
      ]
    },
    {
      path: "/foreaccount",
      component: ConsoleLayout,
      children: [
        { path: "foreaccountRoad", name: "foreaccountroad", component: Foreaccountroad }
      ]
    },
    {
      path: "/foreorder",
      component: ConsoleLayout,
      children: [
        { path: "forentry", name: "forentry", component: Forentry },
        { path: "forentry/create", name: "forentryCreate", component: ForentryCreate },
        { path: "forentry/forReEntryCreate", name: "forReEntryCreate", component: ForReEntryCreate }
      ]
    },
    {
      path: "/forecheck",
      component: ConsoleLayout,
      children: [
        { path: "forelook", name: "forelook", component: Forelook },
        { path: "forelook/single", name: "forelookSingle", component: ForelookSingle }
      ],
    },
    {
      path: "/foresetup",
      component: ConsoleLayout,
      children: [
        { path: "foreability", name: "foreability", component: Foreability },
        { path: "foremessage", name: "foremessage", component: Foremessage },
        { path: "foreaccount", name: "foreaccount", component: Foreaccount },
        { path: "forepermission", name: "forepermission", component: Forepermission }
      ]
    },
    {
      path: "/foreour",
      component: ConsoleLayout,
      children: [
        { path: "forepartner", name: "forepartner", component: Forepartner },
        { path: "foreuserOrganization", name: "foreuserOrganization", component: ForeuserOrganization },
        { path: "foreproject", name: "foreproject", component: Foreproject },
        { path: "foresite", name: "foresite", component: Foresite },
      ]
    },
    {
      path: "/notice",
      name: "notice",
      component: ConsoleLayout,
      redirect: { name: "noticeList" },
      children: [
        { path: "list", name: "noticeList", component: Notice }
      ]
    },
    {
      path: "/transfer",
      component: ConsoleLayout,
      children: [
        { path: "transferList", name: "transferList", component: TransferList },
        { path: "transferDelivery", name: "transferDelivery", component: TransferDelivery },
        { path: "sendGoods", name: "sendGoods", component: SendGoods }
      ]
    },
    {
      path: "/quotation",
      component: ConsoleLayout,
      children: [
        { path: "quotation", name: "quotation", component: Quotation }
      ]
    },
    {
      path: "/financialStatements",
      component: ConsoleLayout,
      children: [
        { path: "companyCost", name: "companyCost", component: CompanyCost },
        { path: "groupCost", name: "groupCost", component: GroupCost }
      ]
    },
    {
      path: "/master-data",
      name: "masterData",
      component: ConsoleLayout,
      meta: {},
      redirect: { name: "masterDataSite" },
      children: [
        {
          path: "site",
          name: "masterDataSite",
          component: MasterDataPage,
          redirect: { name: "siteList" },
          children: [
            {
              path: "list",
              name: "siteList",
              component: SiteList,
            },
            {
              path: "detail-history/:id",
              name: "detailHistory",
              component: DetailHistory,
            },
            {
              path: "add",
              name: "siteAdd",
              component: SiteAdd,
            },
            {
              path: ":id/:mode",
              name: "siteDetail",
              component: SiteAdd,
            },
            {
              path: "history",
              name: "siteHistory",
              component: HistorySite,
            },
          ],
        },
        {
          path: "customer",
          name: "masterDataCustomer",
          component: MasterDataPage,
          redirect: { name: "customerList" },
          children: [
            {
              path: "add",
              name: "customerAdd",
              component: CustomerAdd,
            },
            {
              path: ":id/history",
              name: "customerDetailHistory",
              component: CustomerDetailHistory,
            },
            {
              path: ":id/:mode",
              name: "customerEdit",
              component: CustomerAdd,
            },
            {
              path: "list",
              name: "customerList",
              component: CustomerList,
            },
            {
              path: "history",
              name: "customerHistory",
              component: CustomerHistory,
            },
          ],
        },
        {
          path: "address",
          name: "masterDataAddress",
          component: MasterDataPage,
          redirect: { name: "addressList" },
          children: [
            {
              path: "list",
              name: "addressList",
              component: AddressList,
            },
          ],
        },
        {
          path: "route-code",
          name: "masterDataRouteCode",
          component: MasterDataPage,
          redirect: { name: "routeCodeList" },
          children: [
            {
              path: "list",
              name: "routeCodeList",
              component: () => import("src/pages/routeCode/RouteCodeList.vue"),
            },
          ],
        },
        {
          path: "subcontractor",
          name: "masterDataSubcontractor",
          component: MasterDataPage,
          redirect: { name: "subcontractorList" },
          children: [
            {
              path: "log",
              name: "subcontractorHistory",
              component: () => import("src/pages/site/SubcontracHistoryLog.vue"),
            },
            {
              path: "detail-history/:id",
              name: "subcontractorHistoryDetail",
              component: () => import("src/pages/site/SubcontractorHistoryDetail.vue"),
            },
            {
              path: "list",
              name: "subcontractorList",
              component: () => import("src/pages/site/SubcontractorList.vue"),
            },
            {
              path: "add",
              name: "subcontractorAdd",
              component: () => import("src/pages/site/SubcontractorAdd.vue"),
            },
            {
              path: ":id/:mode",
              name: "subcontractorDetail",
              component: () => import("src/pages/site/SubcontractorAdd.vue"),
            },
          ],
        },
        {
          path: "driver",
          name: "masterDataDriver",
          component: MasterDataPage,
          redirect: { name: "driverList" },
          children: [
            {
              path: "list",
              name: "driverList",
              component: () => import("src/pages/site/DriverList.vue"),
            },
            {
              path: "add",
              name: "driverAdd",
              component: () => import("src/pages/site/DriverAdd.vue"),
            },
            {
              path: ":id/history",
              name: "driverDetailHistory",
              component: () => import("src/pages/site/DriverDetailHistory.vue"),
            },
            {
              path: ":id/:mode",
              name: "driverDetail",
              component: () => import("src/pages/site/DriverAdd.vue"),
            },
            {
              path: "log",
              name: "driverHistory",
              component: () => import("src/pages/site/DriverHistoryLog.vue"),
            },
          ],
        },
        {
          path: "vehicle",
          name: "masterDataVehicle",
          component: MasterDataPage,
          redirect: { name: "vehicleList" },
          children: [
            {
              path: "list",
              name: "vehicleList",
              component: () => import("src/pages/site/VehicleList.vue"),
            },
            {
              path: "add",
              name: "vehicleAdd",
              component: () => import("src/pages/site/VehicleAdd.vue"),
            },
            {
              path: ":id/history",
              name: "vehicleDetailHistory",
              component: () =>
                import("src/pages/site/VehicleDetailHistory.vue"),
            },
            {
              path: ":id/:mode",
              name: "vehicleDetail",
              component: () => import("src/pages/site/VehicleAdd.vue"),
            },
            {
              path: "history",
              name: "vehicleHistory",
              component: () => import("src/pages/site/VehicleHistory.vue"),
            },
          ],
        },
        {
          path: "trailer",
          name: "masterDataTrailer",
          component: MasterDataPage,
          redirect: { name: "vehicleList", query: { tab: "trailer" } },
          children: [
            {
              path: "add",
              name: "trailerAdd",
              component: () => import("src/pages/site/TrailerAdd.vue"),
            },
            {
              path: ":mode/:id/",
              name: "trailerDetail",
              component: () => import("src/pages/site/TrailerAdd.vue"),
            },
          ]
        },
        {
          path: "temperature-type",
          name: "masterDataTemperatureType",
          component: MasterDataPage,
          redirect: { name: "temperatureList" },
          children: [
            {
              path: "list",
              name: "temperatureist",
              component: () =>
                import("src/pages/temperature/TemperatureList.vue"),
            },
          ],
        },
        {
          path: "rest-stop",
          name: "masterDataRestStop",
          component: MasterDataPage,
          redirect: { name: "restStopList" },
          children: [
            {
              path: "list",
              name: "restStopList",
              component: () => import("src/pages/restStop/RestStopList.vue"),
            },
            {
              path: "log",
              name: "restStopHistory",
              component: () => import("src/pages/restStop/RestStopHistoryLog.vue"),
            },
            {
              path: "add",
              name: "restStopAdd",
              component: () => import("src/pages/restStop/RestStopAdd.vue"),
            },
            {
              path: ":id/:mode",
              name: "restStopDetail",
              // Replace with actual page
              component: () => import("src/pages/restStop/RestStopAdd.vue"),
            },
          ],
        },
      ],
    },
    {
      path: "/preview-image",
      name: "previewImage",
      component: () => import("src/pages/preview-image/PreviewImage.vue"),
    },
    {
      path: "/working-time",
      name: "workingTime",
      component: ConsoleLayout,
      redirect: { name: "workingTimeList" },
      children: [
        {
          path: "list",
          name: "workingTimeList",
          component: () => import("src/pages/workingTime/WorkingTimeList.vue"),
        },
      ],
    },
    {
      path: "/reports",
      component: ConsoleLayout,
      children: [
        {
          path: "",
          name: "BQReport",
          component: () => import("src/pages/reports/BQReport.vue"),
        },
      ],
    },
    {
      path: "/activity-tracking/",
      name: "trackingActivity",
      redirect: { name: "trackingActivityList" },
      component: ConsoleLayout,
      children: [
        {
          path: "list",
          name: "trackingActivityList",
          component: () => import("src/pages/activity-tracking/ActivityTracking.vue"),
        },
        {
          path: "detail",
          name: "trackingActivityDetail",
          component: () => import("src/components/activity-tracking/ActivityTrackingDetail.vue"),
          children: [
            {
              path: "shipment/:id",
              name: "ShipmentTrackingDetail",
              component: () => import("src/components/activity-tracking/ShipmentTrackingDetail.vue"),
            },
            {
              path: "job/:id",
              name: "JobTrackingDetail",
              component: () => import("src/components/activity-tracking/JobTrackingDetail.vue"),
            },
            {
              path: "order/:id",
              name: "OrderTrackingDetail",
              component: () => import("src/components/activity-tracking/OrderTrackingDetail.vue"),
            },
          ],
        },
      ],
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  if (!store.state.system.completeSyncAddress) {
    store.dispatch("syncAddress");
  }
  if (to.path.includes("activity-tracking")) {
    document.title = "Activity Tracking";
  } else {
    document.title = "ALL NOW TMS Master Data";
  }
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/config/routes.js